




























import { Component, Prop, Vue } from "vue-property-decorator";

import * as def from "@/definitions";

import GroupNode2 from "./groupNode2/groupNode2.vue"
import Node from "../../node/node.vue"

@Component({
  components: {
    GroupNode2,
      "NodeView" : Node
    }
})
export default class GroupNode1 extends Vue 
{
    @Prop() node! : any;
    @Prop() selectedNode! : any;
    @Prop() hierarchy! : number;

    select(id){
        this.$emit("select" , id)
    }

    open(id , hierarchy){
        this.$emit("open" , id)
    }
    
    get childrenHierarchy(){
        return this.hierarchy + 1;
    }

    private get userConfigColor(){
        return this.$store.getters.userConfigColors.buttonColorCode;
    }

    private get userConfigBackgroundColor(){
        var style = {};
        if(this.node.id == this.selectedNode.id && this.node.hierarchy == this.selectedNode.hierarchy){
            style = {
                position: "relative",
                display: "table",
                width: "calc(100% + " + (16 * this.hierarchy) + "px)",
                height: "25px",
                left : -16 * this.hierarchy + "px",
                backgroundColor : this.$store.getters.userConfigColors.buttonColorRgba,
                pointerEvents: "none"
            }
        }
        return style;
    }

    private get userConfigTextBColorStyle(){
        var style = {
            color : this.$store.getters.userConfigColors.textBColor
        };
        return style;
    }
}
